import scrollTo from '../../../../Public/Frontend/src/js/scroll-to.js';


Function.prototype.throttle = function (milliseconds, context) {
    var baseFunction = this,
        lastEventTimestamp = null,
        limit = milliseconds;

    return function () {
        var self = context || this,
            args = arguments,
            now = Date.now();

        if (!lastEventTimestamp || now - lastEventTimestamp >= limit) {
            lastEventTimestamp = now;
            baseFunction.apply(self, args);
        }
    };
};

;(function () {
    let isHighContrastEnabled = () => window.localStorage.getItem('high-contrast') === 'true';
    const teaserElements = document.querySelectorAll('.square-teaser');
    if (!teaserElements.length) {
        return;
    }

    // on show-more button click scroll to the next element
    Array.from(document.querySelectorAll('.square-teaser .show-more')).forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            // scroll to the next element
            let element = this.closest('.square-teaser').nextSibling;
            while (element.nodeName === '#text') {
                element = element.nextSibling;
            }
            scrollTo($(element));
        }, false);
    });


    // Parallax for Square Teasers
    if (document.querySelector('body.neos-backend')) return;
    if (window.innerWidth < 768) return;

    let current;
    let mX, mY, distance;
    let elements = document.querySelectorAll('.square-teaser .inner, .diamond-structure > ul .room');
    let header = document.getElementById('header');
    let footer = document.getElementById('footer');
    var exampleElement = elements[0];
    var startPosition = {x: getTranslate(exampleElement).x, y: getTranslate(exampleElement).y};
    var isMobile = window.innerWidth < 992;

    function calculateDelta(el, mouseX, mouseY) {
        let rect = el.getBoundingClientRect();
        let offset = {
            top: rect.top + window.scrollY,
            left: rect.left + window.scrollX,
        }

        return {
            x: (mouseX - (offset.left + (rect.width / 2))) / window.innerWidth * -10.5,
            y: (mouseY - (offset.top + (rect.height / 2))) / window.innerHeight * -9
        };
    }

    function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= -rect.height / 2 &&
            rect.bottom <= (window.innerHeight + rect.height || document.documentElement.clientHeight + rect.height)
        );
    }

    function setVisibleClass() {
        elements.forEach(el => {
            el.classList[isInViewport(el) ? 'add' : 'remove']('is-visible')
            current = isInViewport(el) ? el : null;
        })
    }

    function getTranslate(el) {
        var style = window.getComputedStyle(el);
        var matrix = new WebKitCSSMatrix(style.transform);

        return {x: matrix.m41 / el.offsetWidth * 100, y:matrix.m42 / el.offsetWidth * 100};
    }

    function teaserMove(e, d) {
        elements.forEach((el) => {
            if (!el.classList.contains('is-visible')) return;

            if (!e.pageY) {
                mY = mY + d;
            } else {
                mX = e.pageX;
                mY = e.pageY;
            }

            distance = calculateDelta(el, mX, mY);

            el.style.transform = (isHighContrastEnabled() ? 'translate3d(-50%, -50%, 0)' : 'translate3d(' + (distance.x * 1.25 + startPosition.x) +'%, ' + (distance.y * 1.25 + startPosition.y) + '%, 0)');
        })
    }

    if (!isMobile) {
        window.addEventListener('mousemove', function (e) {
            teaserMove(e);
        });
    }
    document.addEventListener('wheel', (e) => {
        setVisibleClass();
        teaserMove(e, e.deltaY);
    });
    window.addEventListener('load', setVisibleClass);
})();

